<template>
  <div class="work-plan">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$lange == 'en' ? 'Project list' : '项目列表'"
        name="project"
      >
        <div class="project">
          <div class="project-title flex-between">
            <div class="flex-between">
              <el-input
                size="mini"
                placeholder="请输入项目名称"
                v-model="projectTableParams.name"
                style="max-width: 200px"
              ></el-input>
              <el-button
                type="primary"
                size="mini"
                @click="doSearch"
                class="button"
                >{{ $lange == "en" ? "Search" : "搜索" }}</el-button
              >
            </div>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-plus"
              @click="addProject = true"
              >{{ $lange == "en" ? "Create project" : "创建项目" }}</el-button
            >
          </div>
          <div class="table-box not-padding">
            <cc-table
              :config="projectTableConfig"
              :params="projectTableParams2"
              :refesh-params="tableRefesh"
            >
            </cc-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="editId ? '编辑项目' : '创建项目'"
      :visible.sync="addProject"
      width="400px"
      @close="dialogClose"
      append-to-body
    >
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        size="mini"
        style="max-width: 300px"
      >
        <el-form-item
          :label="$lange == 'en' ? 'Project' : '项目名称'"
          :required="true"
        >
          <el-input v-model="form.name" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Start' : '开始时间'"
          :required="true"
        >
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="form.startTime"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'End' : '结束时间'"
          :required="true"
        >
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="form.endTime"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Describe' : '项目描述'">
          <el-input
            type="textarea"
            v-model="form.description"
            :rows="4"
            placeholder="请输入项目描述"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="addProject = false">{{
            $lange == "en" ? "Cancel" : "取消"
          }}</el-button>
          <el-button type="primary" @click="onSubmit">{{
            $lange == "en" ? "Submit" : "提交"
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Unit edit' : '单元编辑'"
      :visible.sync="editUnitFlag"
      width="40%"
      append-to-body
    >
      <el-form ref="form" label-width="80px" size="mini" style="max-width: 70%">
        <el-form-item :label="$lange == 'en' ? 'Unit' : '单元'">
          <span>XXXX单元</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Start time' : '开始时间'">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="form.startTime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'End time' : '结束时间'">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="form.endTime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="editUnitFlag = false">{{
            $lange == "en" ? "Cancel" : "取消"
          }}</el-button>
          <el-button type="primary" @click="onSubmit">{{
            $lange == "en" ? "Submit" : "提交"
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "WorkPlan",
  data() {
    return {
      dateValue: "",
      //工作计划表格
      workPlanTableConfig: {
        api: "admin/fsb/workshop/unit/query",
        pageSize: 10,
        showPager: true,
        columns: [
          {
            prop: "workshopProject.name",
            lable: this.$lange == "en" ? "Project" : "项目",
          },
          {
            prop: "name",
            lable: this.$lange == "en" ? "Unit" : "单元",
          },
          {
            prop: "workshopOrderNum",
            lable: this.$lange == "en" ? "Order number" : "订单数量",
          },
          {
            prop: "estimatedWorkingHours",
            lable:
              this.$lange == "en"
                ? "Estimated working hours"
                : "预计工时（小时）",
          },
          {
            prop: "actualWorkingHours",
            lable:
              this.$lange == "en" ? "Actual working hours" : "实际工时（小时）",
          },
          {
            prop: "schedule",
            lable: this.$lange == "en" ? "Productiveness" : "效率",
          },
          {
            prop: "productionSchedule",
            lable: this.$lange == "en" ? "Speed of progress" : "进度",
          },
          {
            prop: "deptName",
            lable: this.$lange == "en" ? "class" : "负责班级",
          },
          {
            lable: this.$lange == "en" ? "Start time" : "开始时间",
            render: (row) => {
              return moment(row.startTime).format("YYYY-MM-DD");
            },
          },
          {
            lable: this.$lange == "en" ? "End time" : "结束时间",
            render: (row) => {
              return moment(row.endTime).format("YYYY-MM-DD");
            },
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Status" : "状态",
            type: "tag",
            options: [
              {
                tagType: "info",
                text: this.$lange == "en" ? "Not yet begun" : "未开始",
              },
              {
                tagType: "warning",
                text: this.$lange == "en" ? "In operation" : "运行中",
              },
              {
                tagType: "success",
                text: this.$lange == "en" ? "Completed" : "已完成",
              },
              {
                tagType: "danger",
                text: this.$lange == "en" ? "Delay" : "延期",
              },
            ],
          },
        ],
      },
      workPlanTableParams: {
        startTime: "",
        endTime: "",
        status: "",
        workshopProjectName: "",
      },
      editUnitItem: {}, //当前编辑的单元
      editUnitFlag: false, //当前编辑的单元弹窗
      //------
      searchTime: [],
      activeName: "project",
      addProject: false, // 创建/编辑项目弹窗
      // 创建/编辑项目表单
      form: {
        name: "",
        startTime: "",
        endTime: "",
        description: "",
      },
      tableRefesh: 1,
      editId: false,
      projectTableParams: {
        name: "",
      },
      projectTableParams2: {
        name: "",

      },
      projectTableConfig: {
        api: "admin/fsb/workshop/project/query",
        showPager: true,
        columns: [
          {
            prop: "id",
            lable: "id",
          },
          {
            prop: "name",
            lable: this.$lange == "en" ? "Project" : "项目名称",
          },
          {
            prop: "description",
            lable: this.$lange == "en" ? "Project description" : "项目描述",
          },

          {
            prop: "processingNum",
            lable: this.$lange == "en" ? "Have in hand" : "进行中",
          },
          {
            prop: "completeNum",
            lable: this.$lange == "en" ? "Completed" : "已完成",
          },
          {
            prop: "extensionNum",
            lable: this.$lange == "en" ? "Incur loss through delay" : "延误",
          },
          {
            lable: this.$lange == "en" ? "Start time" : "开始时间",
            render: (row) => {
              return moment(row.startTime).format("YYYY-MM-DD");
            },
          },
          {
            lable: this.$lange == "en" ? "End time" : "结束时间",
            render: (row) => {
              return moment(row.endTime).format("YYYY-MM-DD");
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Description" : "详情",
            click: (row) => {
              this.$router.push({
                path: "/admin/workshop/plan/des",
                query: {
                  id: row.id,
                  name: row.name,
                },
              });
            },
          },
          {
            name: this.$lange == "en" ? "Edit" : "编辑",
            click: (row) => {
              this.editId = row.id;
              this.addProject = true;
              for (let i in this.form) {
                this.form[i] = row[i];
              }
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "删除",
            click: (row) => {
              let data = {
                id: row.id,
              };
              this.$confirm("此操作将会删除项目下所有内容, 是否确定?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.ccRequest
                  .do("admin/fsb/workshop/project/delete", data, "GET")
                  .then((res) => {
                    this.$message({
                      type: "success",
                      message: "删除成功",
                    });
                    this.tableRefesh = new Date().getTime();
                  })
                  .catch((res) => {
                    this.$message({
                      type: "error",
                      message: res.response.data.message,
                    });
                  });
              });
            },
          },
        ],
      },
    };
  },
  methods: {
    doSearch() {
      this.projectTableParams2 = { ...this.projectTableParams };
    },
    timeChange(res) {
      if (res) {
        this.workPlanTableParams.startTime = res[0];
        this.workPlanTableParams.endTime = res[1];
      } else {
        this.workPlanTableParams.startTime = "";
        this.workPlanTableParams.endTime = "";
      }
    },
    dialogClose() {
      this.editId = false;
      this.form = {
        name: "",
        startTime: "",
        endTime: "",
        description: "",
      };
    },
    //提交创建 / 编辑 项目弹窗
    onSubmit() {
      let data = this.form;
      if (data.name.length < 1) {
        this.$message({type: "error",  message: "请输入项目名称"});
        return;
      }
      if (data.startTime === null || data.startTime === "") {
        this.$message({type: "error", message: "请选择开始时间"});
        return;
      }
      if (data.endTime === null || data.endTime === "") {
        this.$message({type: "error", message: "请选择结束时间"});
        return;
      }
      if (this.editId) {
        data.id = this.editId;
      }
      this.ccRequest
        .do("admin/fsb/workshop/project/save", data, "POSTJSON")
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.tableRefesh = new Date().getTime();
          this.addProject = false;
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  margin-left: 10px;
}
.project,
.plan {
  padding: 20px;
}

.table-box {
  margin-top: 20px;
}
.plan-title {
  justify-content: flex-start;
  padding: 5px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e4e4;
  > p {
    span {
      width: 35px;
      &:first-child {
        margin-right: 10px;
      }
    }

    &:not(:last-child) {
      margin-right: 30px;
    }
  }
}
</style>
